// extracted by mini-css-extract-plugin
module.exports = {"button":"name_button__upcNQ","selectBlocked":"name_selectBlocked__nZaWx","flag":"name_flag__DhUkK"};